import { HTTP_TOKEN } from "./http";

export const getMessages = (campaign_id, params) => {
  return HTTP_TOKEN.get(`campaign/${campaign_id}/message`, { params }).then((result) => {
    return result.data;
  });
};

export const createMessage = (campaign_id, data) => {
  return HTTP_TOKEN.post(`campaign/${campaign_id}/message`, data).then((result) => {
    return result.data;
  });
};


export const updateMessage = (campaign_id, message_id, data) => {
  return HTTP_TOKEN.put(`campaign/${campaign_id}/message/${message_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeMessage = (campaign_id, message_id) => {
  return HTTP_TOKEN.delete(`campaign/${campaign_id}/message/${message_id}`).then((result) => {
    return result.data;
  });
};

export const duplicateMessage = (campaign_id, message_id, data) => {
  return HTTP_TOKEN.post(`campaign/${campaign_id}/message/${message_id}/duplicate`, data).then((result) => {
    return result.data;
  });
};

export const getMessagesAut = (automation_id, params) => {
  return HTTP_TOKEN.get(`automation/${automation_id}/message`, { params }).then((result) => {
    return result.data;
  });
};

export const createMessageAut = (automation_id, data) => {
  return HTTP_TOKEN.post(`automation/${automation_id}/message`, data).then((result) => {
    return result.data;
  });
};


export const updateMessageAut = (automation_id, message_id, data) => {
  return HTTP_TOKEN.put(`automation/${automation_id}/message/${message_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeMessageAut = (automation_id, message_id) => {
  return HTTP_TOKEN.delete(`automation/${automation_id}/message/${message_id}`).then((result) => {
    return result.data;
  });
};

export const duplicateMessageAut = (automation_id, message_id, data) => {
  return HTTP_TOKEN.post(`automation/${automation_id}/message/${message_id}/duplicate`, data).then((result) => {
    return result.data;
  });
};
